import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { StatusCodes } from "http-status-codes";
import { ActionContext, ActionTree } from "vuex";
import SABREService from "@/modules/SabreSegment/services/sabreSegment.service";
import { ISabreSegmentState } from "@/core/interfaces/sabreSegmentState.interface";
import { StoreState } from "@/store/type";

const actions: ActionTree<ISabreSegmentState, StoreState> = {
  async defaultSabreSegmentList(
    context: ActionContext<ISabreSegmentState, StoreState>,
    organizationId: string,
  ) {
    let response: ICoreResponse = {
      success: false,
    };
    try {
      const sabreSegmentService = new SABREService();
      response =
        await sabreSegmentService.getByDefaultSegmentList(organizationId);
      if (response.success && response.status === StatusCodes.OK) {
        return response.data?.data.segment_list;
        //
      } else {
        throw response;
      }
    } catch (err) {
      console.error("Error in fetchSabreSegmentStats:", err);
    } finally {
      //
    }
  },
  async defaultSabreSegmentStats(
    context: ActionContext<ISabreSegmentState, StoreState>,
    organizationId: string,
  ) {
    let response: ICoreResponse = {
      success: false,
    };
    try {
      const sabreSegmentService = new SABREService();
      response =
        await sabreSegmentService.getByDefaultSegmentStats(organizationId);
      if (response.success && response.status === StatusCodes.OK) {
        return response.data?.data;
        //
      } else {
        throw response;
      }
    } catch (err) {
      console.error("Error in defaultSabreSegmentStats:", err);
    } finally {
      //
    }
  },
};

export default actions;
